export default __webpack_public_path__ + "static/media/camera.587786e3.svg";